module.exports = "<p>\r\n  marketing works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/marketing/marketing.component.html
// module id = ./src/app/pages/client/marketing/marketing.component.html
// module chunks = main